<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bicycle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.927 4.624A1 1 0 0020 4h-6a1 1 0 00-1 1v2a1 1 0 001 1h4.262l5.871 10.169-10.067 5.812L11.768 20H12a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1h2.149l8.869 15.361a1 1 0 001.366.366l1.732-1a1 1 0 00.366-1.366l-3.415-5.915 10.066-5.812 6.885 11.923a1 1 0 001.366.366l1.732-1a1 1 0 00.366-1.366l-15.5-26.846a1.318 1.318 0 00-.055-.087zM35 22c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-1.967.517-3.814 1.421-5.412l2.63 4.556a7 7 0 109.413-5.698l-2.566-4.445L35 22zM7.366 26.764l2.022 3.502A5.002 5.002 0 0011 40a4.981 4.981 0 003.293-1.238l2.022 3.502a9 9 0 11-8.948-15.5z"/></svg>
</template>
<script>

export default {
  name: 'IconBicycle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
